import { render, staticRenderFns } from "./school-registrations.vue?vue&type=template&id=035c4863"
import script from "./school-registrations.vue?vue&type=script&lang=js"
export * from "./school-registrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports